import {
  type CreateExpenseInput,
  ENUM_LABELS,
  type ExpenseCategoryRow,
  type ExpenseRow,
} from '#shared/types';

/**
 * The form's starting values: the record being edited, or a blank expense
 * dated `today` (a local `YYYY-MM-DD`, passed in so this stays pure).
 */
export function initialExpenseValues(
  record: ExpenseRow | undefined,
  today: string,
): CreateExpenseInput {
  return {
    category_id: record?.category.id ?? 0,
    incurred_on: record ? record.incurred_on.slice(0, 10) : today,
    amount: record?.amount ?? 0,
    description: record?.description ?? '',
    vendor: record?.vendor ?? '',
    reference: record?.reference ?? '',
    note: record?.note ?? '',
  };
}

/** Active categories as select options. */
export function categoryOptions(
  categories: readonly ExpenseCategoryRow[],
): { value: string; label: string }[] {
  return categories
    .filter((category) => category.is_active)
    .map((category) => ({
      value: String(category.id),
      // The kind rides along in the label because it is what decides which
      // line of the profit-and-loss this lands on, and "Repairs" alone does
      // not tell you it counts as equipment.
      label: `${category.name} — ${ENUM_LABELS.expenseKind[category.kind]}`,
    }));
}
